export default {
    path: '/index',
    component: () =>
        import ('../../views/Index.vue'),
    meta: {
        title: '河北省残疾人就业创业网络服务平台——中国残联官方残疾人求职网站',
        requireAuth: false
    },
    children: [
        {
            path: '/job/',
            component: () =>
                import ('../../views/hunan-cdpe/job/index'),
            meta: {
                title: '残疾人求职招聘找工作-河北省残疾人就业创业网络服务平台',
                requireAuth: false,
                userType: 1
            }
        },
        {
            path: '/demand',
            name: 'jobFairIntroduction',
            component: () =>
                import('../../views/hunan-cdpe/demand/index.vue'),
            meta: {
                title: '需求登记',
                requireAuth: false
            },
        },
        {
            path: '/guidance',
            name: 'jobguidance',
            component: () =>
                import('../../views/hunan-cdpe/guidance/index.vue'),
            meta: {
                title: '就业指导',
                requireAuth: false
            },
        },
        {
            path: '/guidance/detail',
            name: 'jobguidance',
            component: () =>
                import('../../views/hunan-cdpe/guidance/detail.vue'),
            meta: {
                title: '就业指导详情',
                requireAuth: false
            },
        },
        {
            path: '/organ/',
            component: () =>
                import ('../../views/hunan-cdpe/organ'),
            meta: {
                title: '社会机构',
                requireAuth: false,
                userType: 1
            }
        },
        {
            path: '/train/',
            component: () =>
                import ('../../views/hunan-cdpe/train'),
            meta: {
                title: '职业培训-河北省残疾人就业创业网络服务平台',
                requireAuth: false,
                userType: 1
            }
        },
        {
            path: '/train/detail',
            name: 'trainDetail',
            component: () =>
                import ('../../views/hunan-cdpe/train/detail.vue'),
            meta: {
                title: '培训详情-河北省残疾人就业创业网络服务平台',
                requireAuth: false
            }
        },
        {
            path: '/train/list',
            component: () =>
                import ('../../views/hunan-cdpe/train/list.vue'),
            meta: {
                title: '职业培训',
                requireAuth: false,
                userType: 1
            }
        },
        {
            path: '/train/mechanism/list',
            component: () =>
                import ('../../views/hunan-cdpe/train/mechanism/list.vue'),
            meta: {
                title: '职业培训机构库',
                requireAuth: false,
                userType: 1
            }
        },
        {
            path: '/train/mechanism/detail',
            component: () =>
                import ('../../views/hunan-cdpe/train/mechanism/detail.vue'),
            meta: {
                title: '职业培训机构库详情',
                requireAuth: false,
                userType: 1
            }
        },
        {
            path: '/mangan/',
            component: () =>
                import ('../../views/hunan-cdpe/mangan/index'),
            meta: {
                title: '盲人按摩店铺-河北省残疾人就业创业网络服务平台',
                requireAuth: false,
                userType: 1
            },
        },
        {
            path: '/mangan/detail',
            component: () =>
                import ('../../views/hunan-cdpe/mangan/detail'),
            meta: {
                title: '盲人按摩店详情',
                requireAuth: false,
                userType: 1
            },
        },
        {
            path: '/shoppingMall',
            component: () =>
                import ('../../views/hunan-cdpe/shoppingMall/Index'),
            meta: {
                title: '残疾人作品商品详情',
                requireAuth: false,
                userType: 1
            },
        },
        {
            path: '/shoppingMall/detail',
            component: () =>
                import ('../../views/hunan-cdpe/shoppingMall/detail'),
            meta: {
                title: '残疾人作品商品详情',
                requireAuth: false,
                userType: 1
            },
        },

        {
            path: '/create/',
            component: () =>
                import ('../../views/hunan-cdpe/create/index'),
            meta: {
                title: '创业项目-河北省残疾人就业创业网络服务平台',
                requireAuth: false,
                userType: 1
            },
        },
        {
            path: '/create/projectList',
            component: () =>
                import ('../../views/hunan-cdpe/create/project/projectList'),
            meta: {
                title: '残疾人创业-项目列表',
                requireAuth: false,
                userType: 1
            }
        },
        {
            path: '/create/projectDetail',
            component: () =>
                import ('../../views/hunan-cdpe/create/project/projectDetail'),
            meta: {
                title: '残疾人创业-项目详情',
                requireAuth: false,
                userType: 1
            }
        },
        {
            path: '/create/baseList',
            component: () =>
                import ('../../views/hunan-cdpe/create/base/baseList'),
            meta: {
                title: '残疾人创业-基地列表',
                requireAuth: false,
                userType: 1
            }
        },
        {
            path: '/create/baseDetail',
            component: () =>
                import ('../../views/hunan-cdpe/create/base/baseDetail'),
            meta: {
                title: '残疾人创业-基地详情',
                requireAuth: false,
                userType: 1
            }
        },
        {
            path: '/create/activityList',
            component: () =>
                import ('../../views/hunan-cdpe/create/activity/activityList'),
            meta: {
                title: '残疾人创业-活动列表',
                requireAuth: false,
                userType: 1
            }
        },
        {
            path: '/create/activityDetail',
            component: () =>
                import ('../../views/hunan-cdpe/create/activity/activityDetail'),
            meta: {
                title: '残疾人创业-活动详情',
                requireAuth: false,
                userType: 1
            }
        },
        {
            path: '/policy',
            component: () =>
                import ('../../views/hunan-cdpe/policy/index'),
            meta: {
                title: '政策法规',
                requireAuth: false,
                userType: 1
            }
        },
        {
            path: '/new/',
            component: () =>
                import ('../../views/hunan-cdpe/new/index'),
            meta: {
                title: '新闻资讯-河北省残疾人就业创业网络服务平台',
                requireAuth: false,
                userType: 1
            }
        },
        {
            path: '/new/party_list',
            component: () =>
                import ('../../views/hunan-cdpe/new/party_list'),
            meta: {
                title: '党建信息列表',
                requireAuth: false,
                userType: 1
            }
        },
        {
            path: '/new/bussiness_list',
            component: () =>
                import ('../../views/hunan-cdpe/new/bussiness_list'),
            meta: {
                title: '业务动态列表',
                requireAuth: false,
                userType: 1
            }
        },
        {
            path: '/new/msg_list',
            name: 'msg_list',
            meta: {
                title: '通知列表-河北省残疾人就业创业网络服务平台',
            },
            component: () =>
                import ('../../views/hunan-cdpe/new/msg_list'),
        },
        {
            path: '/new/new_list',
            name: 'new_list',
            meta: {
                title: '新闻列表-河北省残疾人就业创业网络服务平台',
            },
            component: () =>
                import ('../../views/hunan-cdpe/new/new_list'),
        },
        {
            path: '/new/people_list',
            name: 'people_list',
            meta: {
                title: '残疾人风采列表-河北省残疾人就业创业网络服务平台',
            },
            component: () =>
                import ('../../views/hunan-cdpe/new/people_list'),
        },
        // {
        //     path: '/people_list',
        //     name: 'people_list',
        //     meta: {
        //         title: '残疾人风采列表-河北省残疾人就业创业网络服务平台',
        //     },
        //     component: () =>
        //         import ('../../views/hunan-cdpe/new/people_list'),
        // },
        {
            path: '/new/policy_list',
            name: 'policy_list',
            meta: {
                title: '政策法规列表-河北省残疾人就业创业网络服务平台',
            },
            component: () =>
                import ('../../views/hunan-cdpe/new/policy_list'),
        },
        {
            path: '/new/party_building',
            name: 'party_building',
            meta: {
                title: '党建信息列表-河北省残疾人就业创业网络服务平台',
            },
            component: () =>
                import ('../../views/hunan-cdpe/new/party_building'),
        },
        {
            path: '/new/new_search',
            name: 'new_search',
            meta: {
                title: '新闻资讯搜索结果-河北省残疾人就业创业网络服务平台',
            },
            component: () =>
                import ('../../views/hunan-cdpe/new/new_search'),
        },
        {
            path: '/skill',
            component: () =>
                import ('../../views/hunan-cdpe/skill/index'),
            meta: {
                title: '职业技能竞赛-河北省残疾人就业创业网络服务平台',
                requireAuth: false,
                userType: 1
            }
        },
        {
            path: '/skill/skillDetail',
            component: () =>
                import ('../../views/hunan-cdpe/skill/skillDetail'),
            meta: {
                title: '技能竞赛详情',
                requireAuth: false,
                userType: 1
            }
        },
        {
            path: '/skill/list',
            component: () =>
                import ('../../views/hunan-cdpe/skill/list'),
            meta: {
                title: '赛事通知',
                requireAuth: false,
                userType: 1
            }
        },
        {
            path: '/skill/newDetail',
            name: 'skill_newDetail',
            meta: {
                title: '赛事详情页面-河北省残疾人就业创业网络服务平台',
            },
            component: () =>
                import ('../../views/hunan-cdpe/skill/newDetail'),
        },
        {
            path: '/psychology',
            component: () =>
                import ('../../views/hunan-cdpe/psychology/index'),
            meta: {
                title: '心理咨询',
                requireAuth: false,
                userType: 1
            }
        },
        {
            path: '/evaluation',
            component: () =>
                import ('../../views/hunan-cdpe/evaluation/index'),
            meta: {
                title: '能力测评',
                requireAuth: false,
                userType: 1
            }
        },
        {
            path: '/evaluation/evaluateDetail',
            component: () =>
                import ('../../views/hunan-cdpe/evaluation/evaluateDetail'),
            meta: {
                title: '预约能力测评',
                requireAuth: false,
                userType: 1
            }
        },
        {
            path: '/massage',
            component: () =>
                import ('../../views/hunan-cdpe/massage/index'),
            meta: {
                title: '盲人按摩专题列表',
                requireAuth: false,
                userType: 1
            }
        },
        {
            path: '/massage/massageDetail',
            component: () =>
                import ('../../views/hunan-cdpe/massage/massageDetail'),
            meta: {
                title: '盲人按摩专题详情',
                requireAuth: false,
                userType: 1
            }
        },
        {
            path: '/massage/seeMore',
            component: () =>
                import ('../../views/hunan-cdpe/massage/seeMore'),
            meta: {
                title: '盲人按摩文章查看更多',
                requireAuth: false,
                userType: 1
            }
        },
        {
            path: '/massage/articleDetail',
            component: () =>
                import ('../../views/hunan-cdpe/massage/articleDetail'),
            meta: {
                title: '盲人按摩文章详情',
                requireAuth: false,
                userType: 1
            }
        },
        {
            path: '/server',
            component: () =>
                import ('../../views/hunan-cdpe/public/server'),
            meta: {
                title: '维护中...',
                requireAuth: false,
                userType: 1
            }
        },
        {
            path: '/jump',
            component: () =>
                import ('../../views/hunan-cdpe/public/jump'),
            meta: {
                title: '跳转',
                requireAuth: false,
                userType: 1
            }
        },
        {
            path: '/activity',
            component: () =>
                import ('../../views/hunan-cdpe/activity/index'),
            meta: {
                title: '2022年河北省残疾人就业宣传年',
                requireAuth: false,
                userType: 1
            }
        },
        {
            path: '/specialSchools',
            component: () =>
                import ('../../views/hunan-cdpe/specialSchools/index'),
            meta: {
                title: '特教学校',
                requireAuth: false,
                userType: 1
            }
        },
        {
            path: '/specialSchools/detail',
            component: () =>
                import ('../../views/hunan-cdpe/specialSchools/detail'),
            meta: {
                title: '特教学校详情',
                requireAuth: false,
                userType: 1
            }
        },
        {
            path: '/public/jobMap',
            component: () =>
                import ('../../views/public/Map/jobMap'),
            meta: {
                title: '求职导图',
                requireAuth: false,
                userType: 1
            }
        },
        {
            path: '/public/jobFairMap',
            component: () =>
                import ('../../views/public/Map/jobFairMap'),
            meta: {
                title: '招聘导图',
                requireAuth: false,
                userType: 1
            }
        },
    ]
}
